import { useState, useEffect } from '@wordpress/element';
import classNames from "classnames";
import {VERSION} from "../config";

const ThemeToggleButton = () => {
  const [theme, setTheme] = useState(() => {
    // Get the theme from localStorage if it exists, otherwise default to 'light'
    const savedTheme = localStorage.getItem('theme');
    return savedTheme ? savedTheme : 'light';
  });

  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    // Save the theme to localStorage
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  return (
    <button onClick={toggleTheme}
            className={classNames('fn-contrast p-2 bg-gray-200 dark:bg-gray-800 text-gray-800 dark:text-gray-200 mb-0')}>
      <svg className={classNames('icon-image')}>
        <use href={`#assets--icons--contrast`}/>
      </svg>
      <span className={classNames('fn-label')}>Kontrast</span>
    </button>
  );
};

export default ThemeToggleButton;
